import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'

import { getProjectType } from 'features/filter/api'
import { GetProjectTypeReq } from 'features/filter/types'
import { selectProjectType } from 'features/filter/selector'
import { Col, Row } from 'antd'
import {
  projectsByIdSelector,
  selectedProjectCodeSelector,
} from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'
import { DropdownList, DropdownPopupMenu } from 'Components/Shared/Form'
import { fetchProjects } from 'features/project/project.api'
import { selectFilter } from 'features/adminReport/constructPlan/selector'
import { Filter } from 'features/adminReport/constructPlan/types'
import {
  updateFilter,
  clearFilter,
} from 'features/adminReport/constructPlan/actions'
import {
  ProjectsFilter,
  ProjectTypeFilter,
  DateFilter,
  ButtonFilter,
  CheckNumberFilter,
} from './Components'
import MulticheckProject from 'Components/Shared/Filters/MulticheckProject'
import { GetDataListReq } from 'features/admin/checklist-config/types'
import { onGetChecklistTypeConfigList } from 'features/admin/checklist-config/api'
import { selectDataList } from 'features/admin/checklist-config/selector'

type Props = {
  onSearch?: (isClear?: boolean) => void
  withPadding?: boolean
  onExport?: () => void
  exportData?: any[]
  isDownLoading?: boolean
} & ReduxProps &
  DispatchProps

const ConstructPlanFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    filter,
    projectsById,
    onSearch = () => {},
    withPadding = false,
    projectType,
    onExport,
    exportData,
    isDownLoading,
    checklistConfigList,
  } = props

  useEffect(() => {
    dispatch(clearFilter())
    onGetProjectType()
    onGetListChecklistType()
    dispatch(fetchProjects({ email: UserEmail, token }))
    return () => {
      dispatch(clearFilter())
    }
  }, [ProjectCode, UserEmail])

  const onGetChecklistType = () => {
    var dropdown = [{ value: 0, name: 'ทั้งหมด' }]
    checklistConfigList.List.filter(
      item => item.ID !== undefined && item.IsActive === 'A'
    ).map(item =>
      dropdown.push({
        value: item.ID as number,
        name: item.ChecklistName,
      })
    )
    return dropdown
  }

  const onGetProjectType = () => {
    const req: GetProjectTypeReq = {
      UserEmail,
      Page: 1,
      RowPerPage: 100,
    }
    dispatch(getProjectType(token, req))
  }

  const onGetListChecklistType = () => {
    const req: GetDataListReq = {
      UserEmail,
      Page: 1,
      RowPerPage: 100,
    }
    dispatch(onGetChecklistTypeConfigList(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    dispatch(updateFilter(filter))
  }

  const onClearSearch = () => {
    dispatch(clearFilter())
    onSearch(true)
  }

  const isFilter = () => {
    return (
      filter.CheckNumber > 0 ||
      filter.CheckStatus !== '' ||
      filter.Date.Mode !== '' ||
      filter.ProjectCode.length > 0 ||
      filter.ProjectTypeID !== 0
    )
  }

  const checkStatus = [
    {
      name: 'ผ่านการตรวจสอบ',
      value: 'Pass',
    },
    {
      name: 'ไม่ผ่านการตรวจสอบ',
      value: 'NotPass',
    },
    {
      name: 'ไม่ผ่านการตรวจสอบ มี require defect',
      value: 'NotPassByReqDefect',
    },
  ]

  const selectedProject =
    filter.ProjectCode.length > 0
      ? `เลือก ${filter.ProjectCode.length} โครงการ`
      : ''

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <Row type="flex" justify="start">
        <Col span={8}>
          <ProjectTypeFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectType={projectType}
          />
        </Col>
        <Col span={8}>
          <Box>
            <DropdownPopupMenu
              label={'โครงการ'}
              placeholder="เลือกโครงการ"
              value={filter.ProjectCode.join(',')}
              disabled={false}
              content={
                <MulticheckProject
                  projectList={projectsById}
                  projectTypeID={filter.ProjectTypeID}
                  filter={filter.ProjectCode}
                  onChange={data => {
                    filter.ProjectCode = data
                    onFilterChange(filter)
                  }}
                />
              }
              isActive={filter.ProjectCode.length > 0}
            />
          </Box>
        </Col>
        <Col span={8}>
          <CheckNumberFilter filter={filter} onFilterChange={onFilterChange} />
        </Col>
        <Col span={8}>
          <Box>
            <DropdownList
              label="คะแนน"
              value={filter.CheckStatus}
              menu={checkStatus}
              onChange={(value: any) => {
                filter.CheckStatus = value
                onFilterChange(filter)
              }}
            />
          </Box>
        </Col>
        <Col span={8}>
          <DateFilter filter={filter} onFilterChange={onFilterChange} />
        </Col>
        <Col span={8}>
          <Box>
            <DropdownList
              label="ประเภท Checklist"
              value={filter.ChecklistTypeID}
              placeholder="เลือก"
              menu={onGetChecklistType()}
              onChange={(value: any) => {
                filter.ChecklistTypeID = value
                onFilterChange(filter)
              }}
            />
          </Box>
        </Col>
        <Col span={16}></Col>
        <Col span={8}>
          <ButtonFilter
            onClearSearch={onClearSearch}
            onSearch={onSearch}
            isFilter={isFilter()}
            onExport={onExport}
            isDownLoading={isDownLoading}
            exportData={exportData}
            fileName="รายงาน Site visit - ระหว่างก่อสร้าง"
          />
        </Col>
      </Row>
    </MainPage>
  )
}

const MainPage = styled.div`
  margin-bottom: 24px;
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const Box = styled.div`
  padding: 0 12px 12px 0;
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    projectType: selectProjectType(state),
    projectsById: projectsByIdSelector(state),
    checklistConfigList: selectDataList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(ConstructPlanFilter)
